import { useMemo, useState } from 'react';
import { Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useToast } from 'context/ToastContext';
import SolarIcon from 'components/icons/SolarIcon';
import { copyToClipboard } from 'utils/helpers/copyToClipboard';
import { formatAppError } from './formatAppError';

interface AppErrorScreenProps {
    error: unknown;
}

const AppErrorScreen = ({ error }: AppErrorScreenProps) => {
    const { t } = useTranslation('common');
    const { showToast } = useToast();
    const [copied, setCopied] = useState(false);
    const report = useMemo(() => formatAppError(error), [error]);

    const handleCopy = async () => {
        const success = await copyToClipboard(report);
        if (!success) {
            showToast(t('messError'), 'danger');
            return;
        }
        setCopied(true);
    };

    return (
        <div className="app-error-screen p-4">
            <div className="text-primary mb-3">
                <SolarIcon name="info-circle" className="fs-2" />
            </div>
            <h5 className="text-body mb-2">{t('appError.title')}</h5>
            <p className="text-muted mb-3">{t('appError.hint')}</p>
            <div className="d-flex flex-wrap gap-2 mb-3">
                <Button type="button" variant="primary" onClick={() => window.location.reload()}>
                    <SolarIcon name="arrow-clockwise" className="me-2" />
                    {t('toolRefreshList')}
                </Button>
                <Button type="button" variant="light-secondary" onClick={() => void handleCopy()}>
                    <SolarIcon name={copied ? 'check-lg' : 'copy'} className="me-2" />
                    {t('clipboard.copy')}
                </Button>
            </div>
            <pre className="app-error-details text-muted fs-12 border rounded p-3 mb-0">{report}</pre>
        </div>
    );
};

export default AppErrorScreen;
